
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import EnumControl from "@/components/controls/base/EnumControl.vue";
import TextControl from "@/components/controls/base/TextControl.vue";
import { DxCheckBox } from "devextreme-vue/check-box";

export default defineComponent({
  components: {
    CreateEditDialog,
    EnumControl,
    IntegerControl,
    TextControl,
    DxCheckBox,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  data() {
    return {
      volumeConstraintItemSubGridDomId:
        "OrderCommentVolumeConstraintCreateEditDialog_volumeConstraintItemSubGridDomId",
    };
  },
  beforeUnmount() {
    (this as any).unmountComponent(
      (this as any).volumeConstraintItemSubGridDomId
    );
  },
  methods: {
    onShown(model: any) {
      (this as any).mountComponent(
        "components/catalogues/OrderCommentCatalogue/OrderCommentVolumeConstraintItemSubCatalogueGrid.vue",
        (this as any).volumeConstraintItemSubGridDomId,
        {
          parentModel: model,
        }
      );
    },
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
  },
});
